import moment from 'moment'
import jq from 'jquery'
import constants from '../lib/constants.js'
const { SERVER_URL, LANGUAGE_CODE } = constants();

/* eslint-disable */
(function() {
    var UNPARSED_ROUTE_REGEX = /\{\w*\}/;

    function generateUrl(route, params) {
        var url = Object.keys(params).reduce(function(url, param) {
            return url.replace('{' + param + '}', encodeURIComponent(params[param]));
        }, route);

        if (UNPARSED_ROUTE_REGEX.test(url)) {
            throw "Unparsed route found in url. Route: " + route + " url after transform: " + url;
        }

        return url;
    }

    var routes = {
        fetchFlutningsMeterData: 'flutningstilkynning/users/{ssn}/utilities/{meter_id}',
        fetchAlestrarMeterData: 'alestrarform/users/{ssn}/utilities/{meter_id}',
        checkFlutningsAddress: 'flutningstilkynning/users/{ssn}/address/{address}',
        addressFlutningsLookup: 'flutningstilkynning/address/lookup/{query}',
        submitFlutningsRelocation: 'flutningstilkynning/submitRelocation',
        submitAlestrarReadings: 'alestrarform/submitReadings',
        registerLyklaUser: 'lyklaform/register',
        submitContactForm: 'hafasamband',
        submitNewCustomer: 'hafasamband',
        fetchAlestrarMeterDataByToken: 'alestrarform/token/{token}',
        fetchFlutningsMeterDataByToken: 'flutningsform/token/{token}'
    };

    function fetchFlutningsMeterData(ssn, meterId, date, cb, http) {
        var url = generateUrl(routes.fetchFlutningsMeterData, {
            ssn: ssn,
            meter_id: meterId
        })

        var data = date ? {date: moment(date).format('YYYY-MM-DD')} : null
        var options = {
            'headers': {'contentType': 'application/json'}
        }

        http.get(SERVER_URL + '/' + url).then((data) => {
          // success callback
          var error = data ? null : new Error('No data returned in a successful request');
          if (data && data.data && typeof data.data === 'object') {
            cb(true, error, data);
          } else {
            cb(false, error, data);
          }
        }, (response) => {
          // error callback
          cb(false, response, data);
        })
        return true
    }

    function fetchAlestrarMeterData(ssn, meterId, date, cb, http) {
        var url = generateUrl(routes.fetchAlestrarMeterData, {
            ssn: ssn,
            meter_id: meterId
        })

        var data = date ? {date: moment(date).format('YYYY-MM-DD')} : null
        var options = {
            'headers': {'contentType': 'application/json'}
        }

        http.get(SERVER_URL + '/' + url).then((data) => {
          // success callback
          var error = data ? null : new Error('No data returned in a successful request');
          if (data && data.data && typeof data.data === 'object') {
            cb(true, error, data);
          } else {
            cb(false, error, data);
          }
        }, (response) => {
          // status may become 0 if we get a server error
          if(response.status === 0) {
            response.status = 500
          }
          // error callback
          cb(false, response, data);
        })
        return true
    }
    // todo: combine these two nearly identical functions into one
    function fetchAlestrarMeterDataByToken(token, date, cb, http) {
        var url = generateUrl(routes.fetchAlestrarMeterDataByToken, {
            token: token
        })

        var data = date ? {date: moment(date).format('YYYY-MM-DD')} : null
        var options = {
            'headers': {'contentType': 'application/json'}
        }

        http.get(SERVER_URL + '/' + url).then((data) => {
          // success callback
          var error = data ? null : new Error('No data returned in a successful request');
          if (data && data.data && typeof data.data === 'object') {
            cb(true, error, data);
          } else {
            cb(false, error, data);
          }
        }, (response) => {
          // error callback
          cb(false, response, data);
        })
        return true
    }

    function fetchFlutningsMeterDataByToken(token, date, cb, http) {
        var url = generateUrl(routes.fetchFlutningsMeterDataByToken, {
            token: token
        })

        var data = date ? {date: moment(date).format('YYYY-MM-DD')} : null
        var options = {
            'headers': {'contentType': 'application/json'}
        }

        http.get(SERVER_URL + '/' + url).then((data) => {
          // success callback
          var error = data ? null : new Error('No data returned in a successful request');
          if (data && data.data && typeof data.data === 'object') {
            cb(true, error, data);
          } else {
            cb(false, error, data);
          }
        }, (response) => {
          // error callback
          cb(false, response, data);
        })
        return true
    }

    function checkFlutningsAddress(ssn, address, cb, http) {
        var url = generateUrl(routes.checkFlutningsAddress, {
            ssn: ssn,
            address: address
        })
        var options = {
            'headers': {'contentType': 'application/json'}
        }

        http.get(SERVER_URL + '/' + url).then((data) => {
            // success callback
            var error = data ? null : new Error('No data returned in a successful request');
            cb(true, error, data);
        }, (response) => {
            // error callback
            cb(false, response);
        })

        return true
    }

    function addressFlutningsLookup(query, cb, http) {
        console.log('addressFlutningsLookup query', query)
        var url = generateUrl(routes.addressFlutningsLookup, {
            query: query
        })

        http.get(SERVER_URL + '/' + url).then((data) => {
          // success callback
          var error = data ? null : new Error('No data returned in a successful request');
            console.log('data', data);
            cb(true, error, data);
        }, (response) => {
          // error callback
            console.log('data', data);
            cb(false, response, data);
        })
    }

    function submitFlutningsRelocation(requestParams, cb) {
        jq.ajax({
            type: 'POST',
            url: SERVER_URL  + '/' + routes.submitFlutningsRelocation,
            // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
            // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
            data: {
                json: JSON.stringify(requestParams)
            },
            success: function (response) {
                cb(true, { response: response, requestParams });
            },
            error: function (response) {
                cb(false, { response: response, requestParams });
            }
        });

        //debug
        /*console.log(data)
        setTimeout(function() {
            cb(true, data.errorDetails, data)
        },2000)*/
    }

    function submitAlestrarReadings(data, cb, http) {
        jq.ajax({
            type: 'POST',
            url: SERVER_URL  + '/' +  routes.submitAlestrarReadings,
            // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
            // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
            data: {
                json: JSON.stringify(data)
            },
            success: function (data) {
                cb(true);
            },
            error: function(response) {
                cb(false, response);
            }
        });

        //debug
        /*
        setTimeout(function() {
            cb(true, data.errorDetails, data)
        },2000)
        */
    }

    // 'http://localhost:1888/lang_is.json' function get

    function fetchLanguageFile(cb) {
        jq.ajax({
            type: 'GET',
            url: SERVER_URL + '/language/' + LANGUAGE_CODE + '?version=' + moment().unix(),
            dataType: "json",
            // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
            // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
            success: function (data) {
                cb(true, data.errorDetails, data);
            },
            error: function (e) {
                cb(false);
            }
        });
    }

    function registerLyklaUser (data) {
        return new Promise((resolve, reject) => {
            jq.ajax({
                type: 'POST',
                url: SERVER_URL + '/' + routes.registerLyklaUser,
                data: {
                    json: JSON.stringify(data)
                },
                // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
                // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
                success: function (data) {
                    resolve(data);
                },
                error: function (e) {
                    reject(e);
                }
            });
        });
    }

    function submitContactForm (data) {
        return new Promise((resolve, reject) => {
            jq.ajax({
                type: 'POST',
                url: SERVER_URL + '/' + routes.submitContactForm,
                data: {
                    json: JSON.stringify(data)
                },
                // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
                // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
                success: function (data) {
                    resolve(data);
                },
                error: function (e) {
                    reject(e);
                }
            });
        });
    }

    function submitNewCustomer (data) {
        return new Promise((resolve, reject) => {
            jq.ajax({
                type: 'POST',
                url: SERVER_URL + '/' + routes.submitNewCustomer,
                data: {
                    json: JSON.stringify(data)
                },
                // The jq.ajax() method has this feature where it will strip out properties that contain empty arrays. So
                // properties such as SubmitData.liUtilities will not end up on the web server if it's empty.
                success: function (data) {
                    resolve(data);
                },
                error: function (e) {
                    reject(e);
                }
            });
        });
    }

    window.Api = {
        fetchFlutningsMeterData: fetchFlutningsMeterData,
        fetchAlestrarMeterData: fetchAlestrarMeterData,
        fetchAlestrarMeterDataByToken: fetchAlestrarMeterDataByToken,
        checkFlutningsAddress: checkFlutningsAddress,
        addressFlutningsLookup: addressFlutningsLookup,
        submitFlutningsRelocation: submitFlutningsRelocation,
        submitAlestrarReadings: submitAlestrarReadings,
        fetchLanguageFile: fetchLanguageFile,
        registerLyklaUser: registerLyklaUser,
        submitContactForm: submitContactForm,
        submitNewCustomer: submitNewCustomer
    };

    // UMD wrapper
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Api;
    } else if (typeof define === 'function' && define.amd) {
        define(Api);
    } else if (window) {
        window.Api = Api;
    }
})();



// WEBPACK FOOTER //
// ./src/lib/api.js